import { render, staticRenderFns } from "./resumo.vue?vue&type=template&id=723889ae&scoped=true"
import script from "./resumo.vue?vue&type=script&lang=js"
export * from "./resumo.vue?vue&type=script&lang=js"
import style0 from "./ranking.css?vue&type=style&index=0&id=723889ae&prod&scoped=true&lang=css&external"
import style1 from "./resumo.vue?vue&type=style&index=1&id=723889ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723889ae",
  null
  
)

export default component.exports